// branch lib
import isObject from 'isobject';

const getTowingServices = (branch) => {
  const towingServices = isObject(branch?.towing_jump_services)
    ? branch?.towing_jump_services?.services
    : []

  return towingServices
};

export default getTowingServices;
